/**
 * Normalizes a string by removing accents and converting to lowercase
 * for case-insensitive and accent-insensitive searching
 */
export const normalizeString = (str: string): string => {
  return str
    .normalize('NFD') // Decompose combined characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim();
};
